import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CloudMigrNatisFormRequest,
  CloudMigrNatisFormResponse,
  NatisDocsRequest,
  NatisDocsResponse,
  NatisReleaseRequest,
  NatisReleaseResponse,
} from '../models/natis-docs.model';
import { CosyUrlResponse, Z11Fp3GetCosyUrlRequest } from '../models/cosy.model';

@Injectable({
  providedIn: 'root',
})
export class NatisDocsService {
  private readonly http = inject(HttpClient);

  getCosyUrl(
    requestPayload: Z11Fp3GetCosyUrlRequest
  ): Observable<CosyUrlResponse> {
    const url = `/cosy-url`;
    return this.http.post<CosyUrlResponse>(url, requestPayload);
  }

  getNatisDocs(
    requestPayload: NatisDocsRequest
  ): Observable<NatisDocsResponse> {
    const url = `/natis-docs`;
    return this.http.post<NatisDocsResponse>(url, requestPayload);
  }

  releaseVehicle(
    requestPayload: NatisReleaseRequest
  ): Observable<NatisReleaseResponse> {
    const url = `/natis-release`;
    return this.http.post<NatisReleaseResponse>(url, requestPayload);
  }

  getNatisDocInfo(
    requestPayload: CloudMigrNatisFormRequest
  ): Observable<CloudMigrNatisFormResponse> {
    const url = `/natis-doc-info`;
    return this.http.post<CloudMigrNatisFormResponse>(url, requestPayload);
  }
}
